import { platformApiFetch } from '@/services/platformApi/client';
import { debugLogger } from '@/utils/debug';

export interface ProviderProfileContact {
  whatsapp_number: string | null;
  whatsapp_verified: boolean;
}

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
const cache = new Map<string, { data: ProviderProfileContact; ts: number }>();

export async function fetchProviderProfileContact(userId: string): Promise<ProviderProfileContact | null> {
  if (!userId) return null;
  // Serve from cache if fresh
  const cached = cache.get(userId);
  const now = Date.now();
  if (cached && now - cached.ts < CACHE_TTL_MS) {
    return cached.data;
  }
  try {
    const data = await platformApiFetch<ProviderProfileContact | null>(`/v1/provider-profile/${userId}`);
    if (data) {
      const normalized: ProviderProfileContact = {
        whatsapp_number: data.whatsapp_number ?? null,
        whatsapp_verified: !!data.whatsapp_verified,
      };
      cache.set(userId, { data: normalized, ts: now });
      return normalized;
    }
    return null;
  } catch (e) {
    debugLogger.error('fetchProviderProfileContact exception', e);
    return null;
  }
}

export function invalidateProviderProfile(userId: string) {
  cache.delete(userId);
}
